import { lazy } from "react";

const routes = [
  {
    path: "/dashboard",
    element: lazy(() => import("../../pages/Dashboard")),
  },
  {
    path: "/settings-dashboard",
    element: lazy(() => import("../../pages/SettingsDashboard")),
  },
];

export default routes;
